import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Connects to data-controller="links-input"
export default class extends Controller {
  static targets = ["container", "template"];

  connect() {
    this.sortable = new Sortable(this.containerTarget, {
      animation: 150,
      handle: ".drag-btn",
      onEnd: this.updateIndexes.bind(this),
    });
  }

  addLink(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML;
    this.containerTarget.insertAdjacentHTML("beforeend", content);
    this.updateIndexes();
  }

  removeLink(event) {
    event.preventDefault();
    const item = event.target.closest(".link-entry");
    item.remove();
    this.updateIndexes();
  }

  updateIndexes() {
    this.containerTarget
      .querySelectorAll(".link-entry")
      .forEach((entry, index) => {
        entry.dataset.index = index;
        entry.querySelectorAll("input").forEach((input) => {
          const name = input.getAttribute("name");
          input.setAttribute("name", name.replace(/\[\d+\]/, `[${index}]`));
        });
      });
  }
}
